import { ProductTagType } from "../../../../zustand/payment/checkout/paymentTypes";

export const ShCheckoutProductFriendlyName = (
    {
        tag,
        prepend = false
    }: {
        tag: ProductTagType,
        prepend?: boolean
    }
) => {

    let preprendElement = prepend ? "7hauben Pass " : "";

    if (tag === "basic") {
        return <>{preprendElement}Basic</>
    } else if (tag === "duo") {
        return <>{preprendElement}Duo</>
    } else if(tag === "premium"){
        return <>{preprendElement}Premium</>
    }else if(tag === "family"){
        return <>{preprendElement}Family</>
    } else{
        return <>{preprendElement}</>
    }
}
